import React from 'react'
// ##
import StaffTable from '../../modules/Staff/components/StaffTable'

export default function SizePage() {
  return <StaffTable />
}
